import { Outlet } from 'react-router-dom';
import { ToastContainer } from '@/components/common';

export default function ManageLayout() {
  return (
    <div className="min-h-screen bg-[#fafafc] flex flex-col relative w-full overflow-hidden" style={{ fontFamily: '"DM Sans", sans-serif' }}>
      <style>{`
        /* Global CSS style overrides to enforce the project's premium DM Sans font across Tailwind and Material UI */
        body, 
        .font-sans,
        .font-display,
        .MuiTypography-root, 
        .MuiButton-root, 
        .MuiTableCell-root, 
        .MuiInputBase-root,
        .MuiMenuItem-root,
        .MuiDialog-root,
        .MuiMenu-root,
        input, 
        select, 
        button,
        textarea {
          font-family: 'DM Sans', sans-serif !important;
        }
      `}</style>
      <main className="flex-1 w-full flex flex-col">
        <Outlet />
      </main>
      <ToastContainer />
    </div>
  );
}
